import gql from 'graphql-tag';

export const EDIT_PRIMARY_DEEP_LINK_MUTATION = gql`
    mutation EditPrimaryDeepLink($data: ManageBulkDeeplinksInput!) {
        updateBulkAffiliateAdditionalLinks(data: $data)
    }
    `;
